module.exports = __webpack_public_path__ + "img/ic_result04.eda5b2ad.png";